import { Hr } from '@euler/app/components/Hr';
import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { Dropdown, DropdownOption } from '@euler/components/dropdown';
import { FormGroup } from '@euler/components/form';
import { useServiceAgentList } from '@euler/functions/useServiceAgentList';
import { memo, useCallback, useMemo } from 'react';

export const ServiceAgentField = memo(() => {
  const { form } = useOrderSearchForm();

  const serviceAgents = useServiceAgentList(null);

  const options = useMemo(
    () =>
      serviceAgents?.map<DropdownOption<number>>(tag => ({
        label: tag.name,
        value: tag.id,
      })) ?? [],
    [serviceAgents],
  );

  const onChange = useCallback(
    (value: number | undefined) => {
      const sa = serviceAgents?.find(x => x.id === value);
      form.serviceAgent.update(sa ? { id: sa.id, name: sa.name } : undefined);
    },
    [form.serviceAgent, serviceAgents],
  );

  return (
    <FormGroup label="服务顾问">
      <Dropdown
        options={options}
        value={form.serviceAgent.value?.id}
        clearable={true}
        placeholder="按服务顾问搜索"
        onChange={onChange as any}
        withTagsView={true}
        tagRemovable={true}
        ItemSeparatorComponent={() => <Hr color="#ddd" />}
      />
    </FormGroup>
  );
});
